var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.model && _vm.model.middlePrimarySecondary
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "page middlePrimarySecondary-page",
            attrs: { id: "print_middlePrimarySecondary" },
          },
          [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "font-size": "30px",
                  "text-align": "center",
                  "font-weight": "600",
                },
              },
              [
                _c(
                  "table",
                  {
                    staticStyle: {
                      width: "100%",
                      "border-collapse": "collapse",
                      border: "none",
                      "letter-spacing": "5px",
                    },
                  },
                  [
                    _c("tbody", [
                      _c(
                        "tr",
                        {
                          staticStyle: {
                            width: "100%",
                            "border-collapse": "collapse",
                            border: "none",
                          },
                        },
                        [
                          _c(
                            "td",
                            {
                              staticStyle: {
                                "border-collapse": "collapse",
                                border: "none",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.model.middlePrimarySecondary.reportName
                                    ? _vm.model.middlePrimarySecondary
                                        .reportName
                                    : "中小学生健康检查表"
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "padding-left": "10px",
                  "text-align": "left",
                  width: "100%",
                  "margin-top": "10px",
                  "border-collapse": "collapse",
                  border: "none",
                },
              },
              [
                _c("tbody", [
                  _c(
                    "tr",
                    { staticStyle: { height: "30px", border: "none" } },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: { width: "65%", border: "none" },
                          attrs: { colspan: "5" },
                        },
                        [
                          _vm._v("学校："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.middlePrimarySecondary.schoolName
                                  ? _vm.model.middlePrimarySecondary.schoolName
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: { width: "100px", border: "none" },
                          attrs: { colspan: "2" },
                        },
                        [
                          _vm._v("入学年份："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.middlePrimarySecondary.admissionTime
                                  ? _vm.model.middlePrimarySecondary
                                      .admissionTime
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "tr",
                    { staticStyle: { height: "30px", border: "none" } },
                    [
                      _c(
                        "td",
                        {
                          staticStyle: { width: "65%", border: "none" },
                          attrs: { colspan: "5" },
                        },
                        [
                          _vm._v("班级："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.middlePrimarySecondary.className
                                  ? _vm.model.middlePrimarySecondary.className
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: { width: "100px", border: "none" },
                          attrs: { colspan: "2" },
                        },
                        [
                          _vm._v("体检日期："),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.model.middlePrimarySecondary.checkDate
                                  ? _vm.model.middlePrimarySecondary.checkDate
                                  : ""
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _c(
              "table",
              {
                staticStyle: {
                  "text-align": "center",
                  width: "100%",
                  "border-collapse": "collapse",
                  border: "1px solid black",
                },
              },
              [
                _c("tbody", [
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("姓名")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.name
                                ? _vm.model.middlePrimarySecondary.name
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("性别")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.sex
                                ? _vm.model.middlePrimarySecondary.sex
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("民族")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.nation
                                ? _vm.model.middlePrimarySecondary.nation
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("出生日期")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.birthday
                                ? _vm.model.middlePrimarySecondary.birthday
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("联系电话")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "3" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.phone
                                ? _vm.model.middlePrimarySecondary.phone
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("家庭住址")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "6" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.address
                                ? _vm.model.middlePrimarySecondary.address
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("既往病史")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "6" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary
                                .pastMedicalHistory
                                ? _vm.model.middlePrimarySecondary
                                    .pastMedicalHistory
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _vm._m(0),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("身高")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.height
                                ? _vm.model.middlePrimarySecondary.height
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("cm")]
                        ),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("体重")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.weight
                                ? _vm.model.middlePrimarySecondary.weight
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("kg")]
                        ),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("体质指数")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.bmi
                                ? _vm.model.middlePrimarySecondary.bmi
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("血压")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.systolicPressure
                                ? _vm.model.middlePrimarySecondary
                                    .systolicPressure
                                : ""
                            )
                          ),
                        ]),
                        _vm._v("/"),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.diastolicPressure
                                ? _vm.model.middlePrimarySecondary
                                    .diastolicPressure
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("mmhg")]
                        ),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("肺活量")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.vitalCapacity
                                ? _vm.model.middlePrimarySecondary.vitalCapacity
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("ml")]
                        ),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("心率")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.pulse
                                ? _vm.model.middlePrimarySecondary.pulse
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("m")]
                        ),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "5" },
                      },
                      [_vm._v("五官检查")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "2" },
                      },
                      [_vm._v("眼")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "2" },
                      },
                      [_vm._v("视力")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("左")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary
                                .nakedLeftEyeVision
                                ? _vm.model.middlePrimarySecondary
                                    .nakedLeftEyeVision
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "2" },
                      },
                      [_vm._v("色觉")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.colorVision
                                ? _vm.model.middlePrimarySecondary.colorVision
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("右")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary
                                .nakedRightEyeVision
                                ? _vm.model.middlePrimarySecondary
                                    .nakedRightEyeVision
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "3" },
                      },
                      [_vm._v("口腔")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("综合情况")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "4" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary
                                .oralCavityComposite
                                ? _vm.model.middlePrimarySecondary
                                    .oralCavityComposite
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("牙列情况")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "4" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary
                                .oralCavityDentition
                                ? _vm.model.middlePrimarySecondary
                                    .oralCavityDentition
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("医生建议")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "4" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary
                                .oralCavityProposal
                                ? _vm.model.middlePrimarySecondary
                                    .oralCavityProposal
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "6" },
                      },
                      [_vm._v("外科检查")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("初潮年龄")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.menarcheAge
                                ? _vm.model.middlePrimarySecondary.menarcheAge
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("岁")]
                        ),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("男性外生殖器")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.manGenitals
                                ? _vm.model.middlePrimarySecondary.manGenitals
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("头部")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.head
                                ? _vm.model.middlePrimarySecondary.head
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("颈部")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.neck
                                ? _vm.model.middlePrimarySecondary.neck
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("甲状腺")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.thyroid
                                ? _vm.model.middlePrimarySecondary.thyroid
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("胸部")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.chest
                                ? _vm.model.middlePrimarySecondary.chest
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("四肢")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.limb
                                ? _vm.model.middlePrimarySecondary.limb
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("皮肤")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.skin
                                ? _vm.model.middlePrimarySecondary.skin
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("淋巴结")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.lymph
                                ? _vm.model.middlePrimarySecondary.lymph
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("脊椎")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.spine
                                ? _vm.model.middlePrimarySecondary.spine
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("疝")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.hernia
                                ? _vm.model.middlePrimarySecondary.hernia
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("外科其他异常")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.surgeryOther
                                ? _vm.model.middlePrimarySecondary.surgeryOther
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "4" },
                      },
                      [_vm._v("内科检查")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("扁桃体")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.tonsil
                                ? _vm.model.middlePrimarySecondary.tonsil
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("先心病")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.chd
                                ? _vm.model.middlePrimarySecondary.chd
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("心律")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.heartRhythm
                                ? _vm.model.middlePrimarySecondary.heartRhythm
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("心音")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.heartSounds
                                ? _vm.model.middlePrimarySecondary.heartSounds
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("肺")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.lung
                                ? _vm.model.middlePrimarySecondary.lung
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("肝")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.liver
                                ? _vm.model.middlePrimarySecondary.liver
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("脾")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.spleen
                                ? _vm.model.middlePrimarySecondary.spleen
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("腹部")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.abdomen
                                ? _vm.model.middlePrimarySecondary.abdomen
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { rowspan: "3" },
                      },
                      [_vm._v("检验项目")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("红细胞")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.rbc
                                ? _vm.model.middlePrimarySecondary.rbc
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("X10¹²/L")]
                        ),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("谷丙转氨酶")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.alt
                                ? _vm.model.middlePrimarySecondary.alt
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("u/L")]
                        ),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("白细胞")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.wbc
                                ? _vm.model.middlePrimarySecondary.wbc
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("X10⁹/L")]
                        ),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("血清总胆红素")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.tsb
                                ? _vm.model.middlePrimarySecondary.tsb
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("umol/L")]
                        ),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("血红蛋白")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.hbalc
                                ? _vm.model.middlePrimarySecondary.hbalc
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("g/L")]
                        ),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("血小板计数")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "2" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.plt
                                ? _vm.model.middlePrimarySecondary.plt
                                : ""
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px",
                            },
                          },
                          [_vm._v("X10⁹/L")]
                        ),
                      ]
                    ),
                  ]),
                  _c("tr", { staticStyle: { "line-height": "27px" } }, [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          width: "70px",
                          height: "50px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                      },
                      [_vm._v("检查结论")]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          "word-wrap": "break-word",
                          overflow: "auto",
                          "flex-wrap": "wrap",
                          "justify-content": "flex-start",
                          width: "100px",
                          "border-collapse": "collapse",
                          border: "1px solid black",
                        },
                        attrs: { colspan: "6" },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.model.middlePrimarySecondary.inspectionResults
                                ? _vm.model.middlePrimarySecondary
                                    .inspectionResults
                                : ""
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "td",
      {
        staticStyle: {
          width: "70px",
          "border-collapse": "collapse",
          border: "1px solid black",
        },
        attrs: { rowspan: "3" },
      },
      [_vm._v("体态和生理"), _c("br"), _vm._v("功能检查")]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }